export const calendarRoutes = [
  {
    path: '/payrollsConfig/:id/calendarGroups',
    name: 'calendarGroups',
    component: () => import('@/modules/calendars/views/ListCalendarGroups.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/calendarGroups/add',
    name: 'createCalendarGroup',
    component: () => import('./views/CreateCalendarGroup.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/calendarGroups/detail/:calendarGroupId',
    name: 'calendarGroupDetail',
    component: () => import('./views/CalendarGroupDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
